import { query } from '../utilities';

export const catalogFilter = (params) => {
    return query('/catalog/filter/', {
        params
    });
};
